<app-content *ngIf='applicationInfo() as applicationInfo'>
  <app-breadcrumbs>
    <li>
      <a routerLink='/e-uslugi'>E-usługi</a>
    </li>
    <li>
      {{ applicationInfo?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      {{ applicationInfo?.name }}
    </h2>
  </section>
  @if (isTabContent()) {
    <app-tab-view
      [simple]='false'
      [centered]='true'>
      @for (item of tabContent(); track $index) {
        <app-tab-panel
          [selected]="$index === 0"
          [name]='item.name'>
          <div class="row">
            <div class="col-12">
              <div [innerHTML]="item.content"></div>
            </div>
          </div>
        </app-tab-panel>
      }
    </app-tab-view>
  } @else {
    <div [innerHTML]="applicationInfo.content"></div>
  }
  <br>
  @if (['/podatek-od-nieruchomosci-in-1', '/podatek-rolny-ir-1', '/podatek-lesny-il-1'].includes(applicationInfo?.url || '') && completedData) {
    <div class="d-flex justify-content-end mb-3">
      <a routerLink="../aktualizacja-danych-kontaktowych-wpio-20" class="btn btn-secondary">
        <strong>
          Zaktualizuj dane kontaktowe
        </strong>
      </a>
    </div>
  }
  <div class='d-flex justify-content-end'>
    @if (authed) {
      @if (completedData) {
        @if (![
          '/przeksztalcenie-prawa-wieczystego-uzytkowania'
        ].includes(applicationInfo?.url || '')) {
          <a class='btn btn-primary' routerLink='skladanie-wniosku'>
            Przejdź do formularza
          </a>
        }
      } @else {
        <app-alert [closable]="false">
          Aby złożyć wniosek, należy wcześniej zaakceptować regulamin oraz wyrazić zgodę na przetwarzanie danych
          osobowych (RODO) w sekcji:&nbsp;<a routerLink="/moje-dane"><strong>Moje&nbsp;dane.</strong></a>
        </app-alert>
      }
    } @else {
      <a class='btn btn-primary' routerLink='/goto-login-gov'>
        Zaloguj się, aby skorzystać z e-usługi
      </a>
    }
  </div>
</app-content>
